import React from "react";
import ParseFloat from "../../../utils/ParseFloat";

export default function ItemOption(props: any) {
  return (
    <div className="chooseVariation w-full checkbox-display">
  <label
    htmlFor={props.id}
    className="flex justify-between items-center w-full cursor-pointer"
    aria-disabled={props.disabled}
    style={{ cursor: props.disabled ? "not-allowed" : "pointer" }}
  >
    <div>
      {props.itemName && (
        <p className="capitalize textMd font-bold subitem-color">
          {props.itemName}
        </p>
      )}
      {props.price > 0 && (
        <p className="textMd text-[#4B4B4B] font-normal">
          {ParseFloat(props.price)}
        </p>
      )}
    </div>

    <input
      type="checkbox"
      defaultChecked={props?.defaultChecked}
      id={props.id}
      name={props.name}
      onChange={props.onchange}
      disabled={props.disabled}
      className="w-5 h-5 accent-black shrink-0"
      style={{ cursor: props.disabled ? "not-allowed" : "pointer" }}
    />
  </label>
</div>

    // <div className="chooseVariation w-full checkbox-display">
    //    <div className="flex justify-between items-center">
    //      <label
    //     htmlFor={props.id}
    //     aria-disabled={props.disabled}
    //     style={{ cursor: props.disabled ? "not-allowed" : "pointer" }}
    //   >
    //     {props.itemName && <p className="capitalize textMd font-bold subitem-color">{props.itemName} </p>}
    //     {props.price > 0 && <p className="textMd text-[#4B4B4B] font-normal"> {ParseFloat(props.price)}</p>}
    //   </label>
    //   <input
    //     type="checkbox"
    //     defaultChecked={props?.defaultChecked}
    //     id={props.id}
    //     name={props.name}
    //     onChange={props.onchange}
    //     disabled={props.disabled}
    //     className="w-5 h-5 accent-black shrink-0"
    //      style={{ cursor: props.disabled ? "not-allowed" : "pointer" }}
    //   />
     
    //   </div>
    // </div>
  );
}

export const ItempOptionSelectRadio = (props?: any) => {
  return <div className=" chooseVariation w-full cursor-not-allowed new-chooseVariation !border-b-0">
     <div className="flex justify-between items-center">
       <label
      htmlFor={props?.id}
      aria-disabled
      style={{ cursor: "not-allowed" }}
    > <p className="textMd text-[#4B4B4B] font-normal"></p>
    </label>
    <input
      type="radio"
      checked
      id={props?.id}
      className="w-5 h-5 accent-black shrink-0"
    />
   
    </div>
  </div>
}
